module.exports = __webpack_public_path__ + "images/unit-icons/new/5x10.svg";